import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { AxiosResponse } from "axios";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";
import { DeletePropertiesResponseSchema } from "../response/DeletePropertiesResponse";

interface Props {
    id: string;
}

export const useRemoveProperties = () => {
    return useMutation({
        mutationKey: ['agents', 'delete'],
        mutationFn: async (formData: Props) => privateApi.delete(`/v4/property/${formData.id}`),
        onSuccess: async (response: AxiosResponse) => {
            const validationResult = DeletePropertiesResponseSchema.safeParse(response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid properties data format");
            }

            return validationResult.data;
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid properties data format");
            } else {
                console.error(`Failed to delete properties`, error);
                throw error;
            }
        }
    })
}